module.exports = {"DASHI_ENDPOINT":"https://dashi.aliyun.com","PROMOTION_ENDPOINT":"https://promotion.aliyun.com","PAGE_ENDPOINT":"https://page.aliyun.com"}


//////////////////
// WEBPACK FOOTER
// /root/9bfb9c1eaa10cce76c5150a1fe202306.json
// module id = 89
// module chunks = 58 59 60